import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

import { isCreamShellRoute } from '../../../themes/bigTopRollout.js';
import './skillBigTopLoading.scss';

/**
 * Minimal full-page loader for big-top skill shells.
 * Animation: pulsing gold star (swap class on root for dot-bounce variant).
 */
export default function SkillBigTopLoading({ message = "The show is about to begin!" }) {
  const location = useLocation();
  const isCreamShell = isCreamShellRoute(location.pathname);

  useEffect(() => {
    const appContent = document.querySelector('.appContent');
    appContent?.classList.add('app-content--skill-big-top');
  }, []);

  return (
    <div
      className={`skill-big-top-loading${isCreamShell ? ' skill-big-top-loading--cream' : ''}`}
      role="status"
      aria-live="polite"
      aria-busy="true"
    >
      <div className="skill-big-top-loading__icon" aria-hidden="true">
        <span className="skill-big-top-loading__star">★</span>
      </div>
      <p className="skill-big-top-loading__text">{message}</p>
    </div>
  );
}
